import { render, staticRenderFns } from "./consult-info17.vue?vue&type=template&id=a1ab68d6&scoped=true"
import script from "./consult-info17.vue?vue&type=script&lang=js"
export * from "./consult-info17.vue?vue&type=script&lang=js"
import style0 from "./consult-info17.vue?vue&type=style&index=0&id=a1ab68d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ab68d6",
  null
  
)

export default component.exports